export const getValueWithPercentage = (value: number, options?: {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}): string => {
  const { minimumFractionDigits = 2, maximumFractionDigits = 2 } = options || {};

  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value/100);
}